import { type FC } from "react";

import styled from "@emotion/styled";

import { ApisHeader } from "./ApisHeader";
import { ApisList } from "./list";

const ApisListPageHeight = styled.div`
    > div {
        /* calc header size = screen height - header - text title */
        height: calc(100vh - 56px - 110px);
        min-height: 600px;
    }
`;

export const ApisPage: FC = () => {
    return (
        <>
            <ApisHeader />
            <ApisListPageHeight>
                <ApisList />
            </ApisListPageHeight>
        </>
    );
};
